import { Grid, Modal as ModalModule, UI, Utils } from 'common';
import isNull from 'lodash/isNull';
import isObject from 'lodash/isObject';
import moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import DateCellRenderer from '../shared/DateCellRenderer.component';
import HistoryCommunication from '../utils/HistoryCommunication';

const { Modal, ModalContext, ModalButtonActionType } = ModalModule;
const { WrappedToolbar, Spinner } = UI;
const { GridPanel } = Grid;
const { Util } = Utils;

// TODO must update fields when data is available
const columnDefs = [
	{
		headerName: 'Ship Date',
		field: 'shipDate',
		width: 120,
		valueGetter: ({ data }) => moment(data.shipDate).toDate(),
		cellRenderer: 'DateCellRenderer',
	},
	{
		headerName: 'SCAN Form Number',
		field: 'manifestId',
		width: 200,
		flex: 1,
	},
	{
		headerName: '# of Items',
		field: 'numberOfItems',
		width: 120,
	},
];

const ReprintScanFormModal = ({ modalId }) => {
	const scanFormPrintContainer = useRef(null);
	const { showError } = useContext(ModalContext);
	// TODO update variables when data is available
	const [selectedScanForm, setSelectedScanForm] = useState(null);
	const [printScanFormValue, setPrintScanFormValue] = useState(null);

	const [scanForms, setScanForms] = useState([]);
	const reactToPrintButton = React.createRef();
	const [isLoading, setLoading] = useState(true);

	useEffect(() => {
		async function fetchManifests() {
			const response = await HistoryCommunication.loadManifests();
			if (HistoryCommunication.isSuccessful(response)) {
				setScanForms(Util.toCamelCase(response.data) || []);
			} else {
				showError({ response });
			}
			setLoading(!isLoading);
		}

		fetchManifests();
	}, []);

	useEffect(() => {
		if (!isNull(printScanFormValue)) {
			reactToPrintButton.current.click();
		}
	}, [printScanFormValue]);

	const showScanFormExpiredErrorMessage = () => {
		showError({
			data: {
				title: 'SCAN Form Expiration',
				description:
					'SCAN Forms and Print Details are only available for reprint for 24 hours.',
				primaryButtonType: ModalButtonActionType.Ok,
				primaryButtonText: 'Ok',
				handleType: 'custom',
			},
		});
	};

	const isScanFormExpired = () => {
		const dateCreatedScanForm = moment(selectedScanForm.dateCreated).add(
			24,
			'hours'
		);
		const currentDate = moment(new Date());
		return currentDate.isAfter(dateCreatedScanForm);
	};

	const printScanForm = () =>
		isScanFormExpired()
			? showScanFormExpiredErrorMessage()
			: setPrintScanFormValue(0);

	const printDetails = () =>
		isScanFormExpired()
			? showScanFormExpiredErrorMessage()
			: setPrintScanFormValue(1);

	const toolbarButtons = [
		{
			label: 'Print SCAN Form',
			icon: 'print-icon',
			onClick: printScanForm,
			disabled: !isObject(selectedScanForm),
			dataqa: 'reprint-scan-form-print-scan-form-button',
		},
		{
			label: 'Print Details',
			onClick: printDetails,
			disabled:
				!isObject(selectedScanForm) || selectedScanForm?.urls[1] === undefined,
			dataqa: 'reprint-scan-form-print-details-button',
		},
	];

	const onSelectionChanged = selection => {
		const selectedReprintScanForm =
			selection.length > 0 ? selection[0].data : null;
		selectedReprintScanForm.urls =
			selectedReprintScanForm.urls.toString().split(',') || [];

		setSelectedScanForm(selectedReprintScanForm);
	};

	return (
		<Modal
			modalId={modalId}
			className="history-scan-form reprint-scan-form-modal"
			header="Reprint SCAN Form"
			hideFooter
		>
			<WrappedToolbar
				className="toolbar"
				buttons={toolbarButtons}
				dataqa="reprint-scan-form-toolbar"
			/>
			<GridPanel
				columnDefs={columnDefs}
				defaultColDef={{
					suppressSizeToFit: true,
					suppressMovable: true,
					sortable: false,
					suppressMenu: true,
				}}
				rowData={scanForms}
				showPagination={false}
				rowSelection="single"
				onSelectionChanged={onSelectionChanged}
				frameworkComponents={{ DateCellRenderer }}
				dataqa="reprint-scan-form-grid"
			/>
			{isLoading && <Spinner msg="Loading Reprint Scan Form..." />}

			{!isNull(printScanFormValue) && (
				<div style={{ display: 'none' }}>
					<div ref={scanFormPrintContainer}>
						<img
							key={printScanFormValue}
							alt="scanform"
							className="history-scan-form scan-form"
							src={selectedScanForm.urls[printScanFormValue]}
						/>
					</div>
				</div>
			)}

			<ReactToPrint
				trigger={() => (
					<button
						type="button"
						style={{ display: 'none' }}
						ref={reactToPrintButton}
					>
						Print
					</button>
				)}
				content={() => scanFormPrintContainer.current}
				onAfterPrint={() => {
					setPrintScanFormValue(null);
				}}
			/>
		</Modal>
	);
};

ReprintScanFormModal.propTypes = {};

export default ReprintScanFormModal;
